import React, { useState, useEffect } from 'react';
import { collection, getDocs, addDoc, query, orderBy } from 'firebase/firestore';
import { db } from './firebase';

const ADMIN_PASSWORD = 'hellfirebestblackm1d1LP!'; // CHANGE THIS!

export default function AdminPanel() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [artistStats, setArtistStats] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (isAuthenticated) {
      loadData();
    }
  }, [isAuthenticated]);

  const handleLogin = () => {
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setMessage('');
    } else {
      setMessage('Incorrect password');
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const reportsSnapshot = await getDocs(
        query(collection(db, 'reports'), orderBy('timestamp', 'desc'))
      );
      const reportsData = reportsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setReports(reportsData);

      const stats = {};
      reportsData.forEach(report => {
        const artist = report.artistName?.toLowerCase() || '';
        if (!stats[artist]) {
          stats[artist] = { human: 0, ai: 0, total: 0 };
        }
        if (report.isAI) {
          stats[artist].ai++;
        } else {
          stats[artist].human++;
        }
        stats[artist].total++;
      });

      const sortedStats = Object.entries(stats)
        .map(([artist, data]) => ({ artist, ...data }))
        .sort((a, b) => b.total - a.total);
      
      setArtistStats(sortedStats);
    } catch (error) {
      console.error('Error loading data:', error);
      setMessage('Error loading data: ' + error.message);
    }
    setLoading(false);
  };

  const addToList = async (artistName, listType) => {
    if (!artistName) return;
    
    const collectionName = listType === 'human' 
      ? 'verifiedHumanArtists' 
      : 'confirmedAIArtists';
    
    try {
      await addDoc(collection(db, collectionName), {
        name: artistName.toLowerCase(),
        addedAt: new Date().toISOString()
      });
      setMessage(`✅ Added "${artistName}" to ${listType === 'human' ? 'Human' : 'AI'} artists!`);
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`❌ Error: ${error.message}. Make sure Firebase rules allow write access.`);
    }
  };

  if (!isAuthenticated) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{
          background: 'white',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
          width: '100%',
          maxWidth: '400px'
        }}>
          <h2 style={{ marginBottom: '20px', textAlign: 'center' }}>Admin Login</h2>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
            placeholder="Enter admin password"
            style={{
              width: '100%',
              padding: '12px',
              marginBottom: '15px',
              border: '2px solid #ddd',
              borderRadius: '8px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }}
          />
          <button
            onClick={handleLogin}
            style={{
              width: '100%',
              padding: '12px',
              background: '#667eea',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Login
          </button>
          {message && (
            <p style={{ color: 'red', marginTop: '15px', textAlign: 'center' }}>
              {message}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '30px'
      }}>
        <h1>Admin Panel</h1>
        <button
          onClick={() => setIsAuthenticated(false)}
          style={{
            padding: '8px 16px',
            background: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          Logout
        </button>
      </div>

      {message && (
        <div style={{
          padding: '15px',
          background: message.includes('✅') ? '#dcfce7' : '#fee2e2',
          border: `2px solid ${message.includes('✅') ? '#16a34a' : '#dc2626'}`,
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          {message}
        </div>
      )}

      <button
        onClick={loadData}
        disabled={loading}
        style={{
          padding: '10px 20px',
          background: '#3b82f6',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: loading ? 'not-allowed' : 'pointer',
          marginBottom: '20px'
        }}
      >
        {loading ? 'Loading...' : 'Refresh Data'}
      </button>

      <div style={{
        background: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginBottom: '30px'
      }}>
        <h2 style={{ marginBottom: '20px' }}>Artist Reports Summary</h2>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f3f4f6' }}>
                <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Artist</th>
                <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>AI Reports</th>
                <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>Human Reports</th>
                <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>Total</th>
                <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {artistStats.map((stat, index) => (
                <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '12px', fontWeight: 'bold' }}>{stat.artist}</td>
                  <td style={{ padding: '12px', textAlign: 'center', color: '#dc2626' }}>{stat.ai}</td>
                  <td style={{ padding: '12px', textAlign: 'center', color: '#16a34a' }}>{stat.human}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{stat.total}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>
                    <button
                      onClick={() => addToList(stat.artist, 'ai')}
                      style={{
                        padding: '6px 12px',
                        background: '#dc2626',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        marginRight: '8px',
                        fontSize: '12px'
                      }}
                    >
                      Add to AI
                    </button>
                    <button
                      onClick={() => addToList(stat.artist, 'human')}
                      style={{
                        padding: '6px 12px',
                        background: '#16a34a',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Add to Human
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div style={{
        background: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginBottom: '20px' }}>Recent Reports ({reports.length})</h2>
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {reports.map(report => (
            <div
              key={report.id}
              style={{
                padding: '15px',
                borderBottom: '1px solid #eee',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div>
                <strong>{report.artistName}</strong>
                <span style={{
                  marginLeft: '10px',
                  padding: '4px 8px',
                  background: report.isAI ? '#fee2e2' : '#dcfce7',
                  color: report.isAI ? '#dc2626' : '#16a34a',
                  borderRadius: '4px',
                  fontSize: '12px'
                }}>
                  {report.isAI ? 'AI' : 'Human'}
                </span>
                <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                  {report.reason && `Reason: ${report.reason}`}
                </div>
              </div>
              <div style={{ fontSize: '12px', color: '#999' }}>
                {new Date(report.timestamp).toLocaleDateString()}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}